import { Host, h } from '@stencil/core';
import cn from 'classnames';
import { MAX_DISPLAYED_NUMBER_OF_RECORDS, productOfProductsTranslations, PRODUCTS_LABEL_TRANSLATION, } from './constants';
export class SwitchCardView {
  constructor() {
    this.listViewLabel = undefined;
    this.gridViewLabel = undefined;
    this.areLabelsShown = true;
    this.isGridView = undefined;
    this.productOfProductsLabel = undefined;
    this.productsLabel = undefined;
    this.firstRecNum = undefined;
    this.lastRecNum = undefined;
    this.totalNumRecs = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  get productOfProductsText() {
    if (this.totalNumRecs > MAX_DISPLAYED_NUMBER_OF_RECORDS) {
      return this.productOfProductsLabel
        .replace(productOfProductsTranslations.FROM, this.firstRecNum.toString())
        .replace(productOfProductsTranslations.TO, this.lastRecNum.toString())
        .replace(productOfProductsTranslations.ALL, this.totalNumRecs.toString());
    }
    if (this.productsLabel.includes(PRODUCTS_LABEL_TRANSLATION)) {
      return this.productsLabel.replace(PRODUCTS_LABEL_TRANSLATION, this.totalNumRecs.toString());
    }
    return `${this.totalNumRecs} ${this.productsLabel}`;
  }
  clickButtonHandler(isGrid) {
    this.toggleCardView.emit(isGrid);
  }
  render() {
    const gridClass = cn({
      button: true,
      'button-grid': true,
      active: this.isGridView,
      'button--without-labels': !this.areLabelsShown,
    });
    const listClass = cn({
      button: true,
      'button-list': true,
      active: !this.isGridView,
      'button--without-labels': !this.areLabelsShown,
    });
    return (h(Host, { class: "switch-view" }, h("button", { type: "button", class: listClass, onClick: () => this.clickButtonHandler(false), innerHTML: this.areLabelsShown ? this.listViewLabel : '&nbsp;', title: this.areLabelsShown ? null : this.listViewLabel }), h("button", { type: "button", class: gridClass, onClick: () => this.clickButtonHandler(true), innerHTML: this.areLabelsShown ? this.gridViewLabel : '&nbsp;', title: this.areLabelsShown ? null : this.gridViewLabel }), this.productOfProductsLabel && (h("span", { class: cn('product-of-products', {
        'product-of-products--without-button-labels': !this.areLabelsShown,
      }) }, this.productOfProductsText))));
  }
  static get is() { return "pdp-switch-card-view"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["switch-card-view.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["switch-card-view.css"]
    };
  }
  static get properties() {
    return {
      "listViewLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "list-view-label",
        "reflect": false
      },
      "gridViewLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "grid-view-label",
        "reflect": false
      },
      "areLabelsShown": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "are-labels-shown",
        "reflect": false,
        "defaultValue": "true"
      },
      "isGridView": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-grid-view",
        "reflect": false
      },
      "productOfProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "\"#from what element the product is displayed# - #to what element the product is displayed# of #all the products# products\""
            }],
          "text": "Raw string with placeholders for number of displayed records and total number of records."
        },
        "attribute": "product-of-products-label",
        "reflect": false
      },
      "productsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "\"Products\""
            }],
          "text": "String with label that will be displayed if there are less that 11 records."
        },
        "attribute": "products-label",
        "reflect": false
      },
      "firstRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of the first displayed record."
        },
        "attribute": "first-rec-num",
        "reflect": false
      },
      "lastRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of the last displayed record."
        },
        "attribute": "last-rec-num",
        "reflect": false
      },
      "totalNumRecs": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Total number of records."
        },
        "attribute": "total-num-recs",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "toggleCardView",
        "name": "toggleCardView",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
}
